import { Card } from '@/modules/common/components/offer-card';
import styles from './index.module.sass';
import { useEffect, useState } from 'react';
import { AddOfferModal } from '@/modules/common/components/add-offer-modal';
import { AddOfferButton } from './components/add-offer-button';
import {
  $buyerOffers,
  $buyerOffersLoadingStatus,
  deleteBuyerOfferFx,
  fetchBuyerOffersFx,
  updateBuyerOfferFx,
} from '../../store/offers.store';
import { createBuyerOffer } from '../../functions/create-buyer-offer.function';
import { updateBuyerOffer } from '../../functions/update-buyer-offer.function';
import { useStore } from 'effector-react';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import { notification } from 'antd';

export const BuyerOffers = () => {
  useEffect(() => {
    fetchBuyerOffersFx();
  }, []);

  const [showOfferModal, setShowOfferModal] = useState(false);
  const data = useStore($buyerOffers);
  const loadingStatus = useStore($buyerOffersLoadingStatus);

  return (
    <div className={styles.root}>
      <div className={styles.offers}>
        {loadingStatus?.loading || loadingStatus?.error ? (
          <UniversalLoader error={loadingStatus?.error} />
        ) : (
          <>
            <AddOfferButton onClick={() => setShowOfferModal(true)} />
            {data?.map((item, i) => (
              <Card
                hideSwitch={true}
                key={i}
                title={`Пшеница, ${item.class}`}
                setShowOfferModal={setShowOfferModal}
                editable={true}
                enabled={0}
                handleSwitch={async () => {}}
                handleDelete={async () => {
                  try {
                    const res = await deleteBuyerOfferFx(item.id);
                    // @ts-ignore
                    if (res.success) {
                      notification.success({
                        message: 'Предложение успешно удалено из системы',
                      });
                    }
                  } catch (err) {
                    // notification.warning({
                    //   message: 'Что-то пошло не так. Попробуйте, пожалуйста, позже',
                    // });
                  } finally {
                    await fetchBuyerOffersFx();
                  }
                }}
                data={{ ...item, expiration_offer: `${item.expiration_offer} UTC`} as any}
              />
            ))}
          </>
        )}
      </div>
      {showOfferModal && (
        <AddOfferModal
          visible={showOfferModal}
          closeFn={() => setShowOfferModal(false)}
          customCreateFoo={createBuyerOffer}
          customUpdateFoo={updateBuyerOffer}
        />
      )}
    </div>
  );
};
